import { useEffect, useRef } from 'react';
import { useTRPC } from '../trpc/client';
import { useQuery } from "@tanstack/react-query";

export function useApiVersionCheck(): void {
  const trpc = useTRPC();
  const lastVersion = useRef<number | undefined>(undefined);
  
  const queryOptions = trpc.apiVersion.queryOptions(undefined);
  
  const { data: currentVersion } = useQuery({
    ...queryOptions,
    staleTime: 0, // Always stale - refetches on window focus, mount, etc.
  });

  useEffect(() => {
    if (!currentVersion) return;

    if (lastVersion.current && lastVersion.current !== currentVersion) window.location.reload();
    lastVersion.current = currentVersion;
  }, [currentVersion]);
}
